import styled from "styled-components";

export {
	SectionCard,
	SectionHeader,
	SectionTitle,
	ContentDivider,
	ControlsPanel,
	ControlsRow,
} from "../../elements";

export const ChartContainer = styled.div`
	position: relative;
	width: 100%;
	height: ${({ $height }) => $height || 280}px;
	padding: 12px 10px 8px;
	border-radius: 16px;
	background: linear-gradient(180deg, rgba(110, 113, 145, 0.08) 0%, rgba(0, 0, 0, 0.12) 100%);
	border: 1px solid rgba(110, 113, 145, 0.14);
	overflow: hidden;
`;

export const ChartLabel = styled.div`
	margin-bottom: 8px;
	color: var(--secondary-text-color);
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.4px;
`;

export const TableSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	width: 100%;
`;

export const TableTitleRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 10px;
	flex-wrap: wrap;
`;

export const TableTitle = styled.h3`
	margin: 0;
	color: var(--content-text-color);
	font-size: 14px;
	font-weight: 700;
	line-height: 20px;
`;

export const TableBadge = styled.span`
	display: inline-flex;
	align-items: center;
	padding: 4px 10px;
	border-radius: 50px;
	background: rgba(99, 179, 237, 0.15);
	color: #63b3ed;
	font-size: 11px;
	font-weight: 600;
`;

export const StyledTableWrapper = styled.div`
	width: 100%;
	overflow: hidden;
	border-radius: 14px;
	border: 1px solid rgba(110, 113, 145, 0.12);
	background: rgba(0, 0, 0, 0.08);
`;

export const ScrollableTableBody = styled.div`
	max-height: ${({ $maxHeight }) => $maxHeight || 420}px;
	overflow-x: auto;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;

	.ant-spin-nested-loading,
	.ant-spin-container {
		width: 100%;
	}

	.ant-table {
		background: transparent;
		color: var(--content-text-color);
		width: 100%;
	}

	.ant-table-container {
		width: 100%;
	}

	.ant-table-thead > tr > th {
		position: sticky;
		top: 0;
		z-index: 2;
		background: rgba(110, 113, 145, 0.12) !important;
		color: var(--secondary-text-color) !important;
		font-size: 10px;
		font-weight: 700;
		text-transform: uppercase;
		letter-spacing: 0.5px;
		border-bottom: 1px solid rgba(110, 113, 145, 0.2) !important;
		padding: 12px 14px !important;
		white-space: nowrap;
	}

	.ant-table-tbody > tr > td {
		background: transparent;
		color: var(--content-text-color);
		font-size: 12px;
		border-bottom: 1px solid rgba(110, 113, 145, 0.1) !important;
		padding: 12px 14px !important;
		vertical-align: middle;
	}

	.ant-table-tbody > tr:nth-child(even) > td {
		background: rgba(110, 113, 145, 0.04) !important;
	}

	.ant-table-tbody > tr:hover > td {
		background: rgba(99, 179, 237, 0.08) !important;
	}

	.ant-table-tbody > tr:last-child > td {
		border-bottom: none !important;
	}
`;

export const InfiniteScrollSentinel = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 48px;
	padding: 8px 16px 14px;
	color: var(--secondary-text-color);
	font-size: 11px;
	font-weight: 600;
	letter-spacing: 0.2px;
`;

export const DurationCell = styled.span`
	font-weight: 700;
	color: #63b3ed;
`;

export const IpCell = styled.span`
	font-family: "SF Mono", "Menlo", "Monaco", monospace;
	font-size: 11px;
	color: var(--secondary-text-color);
`;

export const EndReasonTag = styled.span`
	display: inline-flex;
	align-items: center;
	padding: 3px 10px;
	border-radius: 50px;
	font-size: 10px;
	font-weight: 700;
	text-transform: capitalize;
	letter-spacing: 0.2px;
	background: ${({ $variant }) =>
		$variant === "logout"
			? "rgba(76, 175, 134, 0.18)"
			: $variant === "relogin"
				? "rgba(255, 183, 77, 0.18)"
				: "rgba(110, 113, 145, 0.2)"};
	color: ${({ $variant }) =>
		$variant === "logout"
			? "#4CAF86"
			: $variant === "relogin"
				? "#FFB74D"
				: "var(--secondary-text-color)"};
	border: 1px solid
		${({ $variant }) =>
			$variant === "logout"
				? "rgba(76, 175, 134, 0.35)"
				: $variant === "relogin"
					? "rgba(255, 183, 77, 0.35)"
					: "rgba(110, 113, 145, 0.25)"};
`;
